import ReactOnRails from 'react-on-rails';
import LoginLink from './components/login_link';
import LoginModal from './components/landing_page/LoginModal';
import PlaylistsWidget from './components/landing_page/PlaylistsWidget';
import IncentivesWidgetWrapper from './components/landing_page/IncentivesWidgetWrapper';
import RecommendationWidgetWrapper from './components/landing_page/RecommendationWidgetWrapper';
import FeaturedContentWidget from './components/landing_page/FeaturedContentWidget';
import FeaturedContentVideoWidget from './components/landing_page/FeaturedContentVideoWidget';
import { InteractiveNotifications } from '@everfi/reactifi/src/components/InteractiveNotifications';
import LearnerDashboardApp from './apps/LearnerDashboard/';
import TrueLearnerDashboardApp from './apps/TrueLearnerDashboard/';
import ContentLibraryApp from './apps/ContentLibrary/';
import HelpModal from './components/help_modal';
import ImportConfigModal from '../admin/components/ImportConfigModal';
import MenuDropdown from './components/MenuDropdown';
import { SidebarMenu } from '@everfi/reactifi/src/components/sidebar/sidebar-menu';
import { HeaderMenu } from '@everfi/reactifi/src/components/HeaderMenu';
import { SystemNotifications } from '@everfi/reactifi/src/components/system-notifications';
import { ProgressSpinner } from '@everfi/reactifi/src/components/progress-spinner';
import ContentApp from '@everfi/content-player';
import ContentWrapperApp from './apps/ContentWrapper/';
import Embed from './apps/ContentWrapper/components/Embed';
import ContentLegalCustomizations from './apps/LearnerDashboard/components/ContentLegalCustomizations';
import { AutoLogout } from '../../lib/components/AutoLogout';
import { RailsReactHookWrapper } from '@everfi/reactifi/src/components/RailsReactHookWrapper';
import { LanguageDropdown } from '@everfi/reactifi/src/components/LanguageDropdown';
import { NextHeaderWrapper } from './components/NextHeaderWrapper';
import InactiveOrganization from './components/InactiveOrganization';
import { HeapTracking } from './components/HeapTracking';
import ChakraComponentWrapper from '../../lib/components/ChakraComponentWrapper';
import PlaylistCardsContainer from './components/landing_page/PlaylistCardsContainer';

require('./startup');

ReactOnRails.register({
  LoginLink,
  LoginModal,
  PlaylistsWidget,
  FeaturedContentWidget,
  FeaturedContentVideoWidget,
  InactiveOrganization,
  IncentivesWidgetWrapper,
  InteractiveNotifications,
  LearnerDashboardApp,
  TrueLearnerDashboardApp,
  ContentLibraryApp,
  ContentWrapperApp,
  HelpModal,
  ImportConfigModal,
  HeaderMenu,
  NextHeaderWrapper,
  LanguageDropdown,
  SidebarMenu,
  MenuDropdown,
  ProgressSpinner,
  ContentApp,
  ContentLegalCustomizations,
  Embed,
  AutoLogout,
  RailsReactHookWrapper,
  SystemNotifications,
  RecommendationWidgetWrapper,
  HeapTracking,
  ChakraComponentWrapper,
  PlaylistCardsContainer,
});
